import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, Modal, Button, Form } from "react-bootstrap";
import Color from "../../assets/color";

// Components
import Icon from "../Icon";
import color from "../../assets/color";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";
import Geocode from "react-geocode";

import { google_api_key } from "../../config";

class Location extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locationListing: this.props.locationList,
      selected: false,
      selected_area: this.props.storeLocation.data.state,
      selected_district: this.props.storeLocation.data.district,
      m_show: false,
    };
  }

  componentDidMount() {
    const { isFirstLoad } = this.props;
    if (isFirstLoad === true) {
      this.props.showModalLocation();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { storeLocation, locationModalVisible, isFirstLoad } = this.props;

    if (prevProps.locationModalVisible !== locationModalVisible) {
      // Get location list
      // Get location list when open modal
      if (locationModalVisible) {
        this.props.onGetListLocation();
      }
      // If user didn't set location
      if (
        locationModalVisible === false &&
        JSON.stringify(storeLocation.data) === JSON.stringify({})
      ) {
        // get current location from google map
        this._getCurrentLocation();
      }
      // Get location of current set every time open or close modal
      if (isFirstLoad === false && locationModalVisible) {
        this.setState({
          selected_area: storeLocation.data.state,
          selected_district: storeLocation.data.district,
          m_show: true,
        });
      }
    }
    // When user ignore the google map which didn't click on block or allow or close button, then directly go to other page
    if (
      isFirstLoad === false &&
      JSON.stringify(storeLocation.data) === JSON.stringify({})
    ) {
      this._submitLocation("Melaka", "Melaka");
    }

    if (prevProps.storeLocation !== this.props.storeLocation) {
      this.setState({
        selected_area: storeLocation.data.state,
        selected_district: storeLocation.data.district,
        m_show: true,
      });
    }
  }

  _getCurrentLocation = (data) => {
    const position = (pos) => {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, pos);
      });
    };

    position()
      .then((data) => {
        let coordinate = {
          lat: parseFloat(data.coords.latitude),
          lng: parseFloat(data.coords.longitude),
        };

        Geocode.setApiKey(google_api_key + "&region=my");
        // Convert coordinate to address
        Geocode.fromLatLng(coordinate.lat, coordinate.lng)
          .then((data) => {
            let address = data.results[0].formatted_address;
            let res_addr = address.split(" ");
            let address_arr = res_addr;
            // Modify google malacca TO melaka
            res_addr.forEach((v, idx) => {
              if (v.includes("Malacca") || v.includes("Melaka")) {
                address_arr[idx] = "Melaka";
              }
            });

            // Compare location - array
            const { locationList } = this.props;
            locationList.forEach((d, i) => {
              address_arr.forEach((v, n) => {
                if (d.state === v) {
                  this._submitLocation(d.state, d.state);
                }
              });
            });
          })
          .catch((err) => {
            // console.log("err", err);
            this._submitLocation("Melaka", "Melaka");
          });
      })
      .catch((err) => {
        // console.log("err", err);
        this._submitLocation("Melaka", "Melaka");
      });
  };

  _selectedArea = (data) => {
    const { storeLocation } = this.props;
    // firstLoad
    if (storeLocation.isFirstLoad === false) {
      this.setState({
        selected_area: storeLocation.data.state,
      });
    }
    // onchange
    this.setState({
      selected_area: data,
      selected: true,
      m_show: true,
    });
  };

  _selectedColor = (area) => {
    let color = "";
    if (area === this.state.selected_area) {
      color = Color.primary;
    }
    return color;
  };

  _activeColor = (area) => {
    let color = "";
    if (area === this.state.selected_area) {
      color = "active";
    }
    return color;
  };

  _onChangeSelectedState = (e, state) => {
    this.setState({
      selected_district: e.target.value,
      selected_area: state,
    });
  };

  _selectedDistrict = (type) => {
    const { locationList } = this.props;
    const { selected_area, selected_district } = this.state;
    let selected = locationList.find((x) => x.state === selected_area);
    let check = null;
    if (locationList.length !== 0) {
      if (type === "str") {
        selected.district.forEach((d, i) => {
          if (d === selected_district) {
            check = " > " + d;
          }
        });
      } else {
        selected.district.forEach((d, i) => {
          if (d === selected_district) {
            check = true;
          }
        });
      }
    }

    return check;
  };

  _selectedLocation = (val) => {
    const { data } = this.props;
    let selected = data.find((x) => x.state_name === val);
    if (data.length !== 0) {
      if (selected.state_name === this.state.selected_area) {
        return true;
      }
    }
  };

  _submitLocation = (state, district) => {
    let params = {};
    params.state = state;
    params.district = district;
    this.props.onSubmitLocation(params);
  };

  _validate = (district) => {
    let disabled = true;
    district.forEach((d) => {
      if (d === this.state.selected_district) {
        disabled = false;
      }
    });

    return disabled;
  };

  _checked = (val) => {
    let checked = false;
    if (this.state.selected_district === val) {
      checked = true;
    }
    return checked;
  };

  _renderLocation = () => {
    const { isLoading, locationList } = this.props;
    return (
      <div className="location mb-3 mb-md-0">
        <h1 className="pl-3 pl-sm-1">LOCATION</h1>
        {isLoading === false ? (
          locationList.length !== 0 && (
            <div className="state">
              {locationList.map((data, index) => {
                return (
                  <div
                    key={index}
                    className="area"
                    onClick={() => this._selectedArea(data.state)}
                  >
                    <Icon
                      type="simple-line-icons"
                      name="location-pin"
                      size={18}
                      color={this._selectedColor(data.state)}
                    />
                    <p className={`place ${this._activeColor(data.state)}`}>
                      {data.state}
                    </p>
                  </div>
                );
              })}
            </div>
          )
        ) : (
          <p className="loading">Loading...</p>
        )}
      </div>
    );
  };

  _renderCloseIcon = () => {
    const { hideModalLocation } = this.props;
    return (
      <div className="btn-close" onClick={hideModalLocation}>
        <Icon type="custom" name="closecircle" color={color.black} size={30} />
      </div>
    );
  };

  _renderAreaDistrict = () => {
    const { locationList, hideModalLocation } = this.props;
    const { selected_area, selected_district } = this.state;
    return (
      <React.Fragment>
        {selected_area !== undefined ? (
          // Select state & area
          <div className="select-state-area p-3 p-md-0">
            <h3 className="title">Select state &amp; area</h3>
            <p className="d-locate-area">
              <span>{selected_area}</span>
              {this._selectedDistrict("str")}
            </p>
            {/* Area list */}

            {locationList.length !== 0 && (
              <div className="area-list">
                <div className="scroll-list">
                  {locationList.map((d, i) => {
                    return d.state === selected_area ? (
                      <div key={i} className="mb-3">
                        {d.district.map((v, idx) => {
                          return (
                            <Form.Check
                              key={idx}
                              inline
                              type="radio"
                              id={"radio-option-" + idx}
                              label={v}
                              onChange={(e) =>
                                this._onChangeSelectedState(e, d.state)
                              }
                              checked={this._checked(v)}
                              value={v}
                              name="radiobuttonset"
                            />
                          );
                        })}
                      </div>
                    ) : null;
                  })}
                </div>
              </div>
            )}
            {/* END Area list */}
            {/* Button Cancel & Confirm*/}
            {locationList.map((d, i) => {
              return (
                d.state === selected_area && (
                  <div key={i} className="btn-action">
                    <Button
                      variant="light"
                      size="lg"
                      onClick={hideModalLocation}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      size="lg"
                      disabled={this._validate(d.district)}
                      onClick={() =>
                        this._submitLocation(selected_area, selected_district)
                      }
                    >
                      Confirm
                    </Button>
                  </div>
                )
              );
            })}
            {/* End Button Cancel & Confirm*/}
          </div>
        ) : (
          // END Select state & Area - Desktop
          <div className="select-text-locate ">
            <p className="text-center">Please select a location</p>
          </div>
        )}
      </React.Fragment>
    );
  };

  _position = () => {
    let position = "justify-content-end";
    const { m_show } = this.state;
    if (m_show) {
      position = "justify-content-between";
    }
    return position;
  };
  _backBtn = () => {
    this.setState({
      m_show: false,
    });
  };

  render() {
    const { hideModalLocation, locationModalVisible } = this.props;
    const { m_show, selected_area } = this.state;
    return (
      <Modal
        size="lg"
        show={locationModalVisible}
        onHide={hideModalLocation}
        aria-labelledby="example-modal-sizes-title-lg"
        centered={true}
        backdrop="static"
        className="modal-home-location"
      >
        {/* Desktop */}
        <div className="d-none d-sm-block">
          <Row noGutters={true}>
            <Col lg={6} sm={6}>
              <div className="inner-container grey position-relative d-flex flex-column">
                {this._renderLocation()}
              </div>
            </Col>
            <Col lg={6} sm={6}>
              {/* Hide Modal Location */}
              <div className="inner-container d-flex flex-column justify-content-center">
                {this._renderCloseIcon()}
                {this._renderAreaDistrict()}
              </div>
              {/*END inner-container */}
            </Col>
          </Row>
        </div>
        {/* Mobile  */}
        {window.innerWidth < 768 && (
          <div className="d-block d-sm-none mobile">
            <div className="mobile-btn-action">
              <div
                className={`d-flex ${this._position()} px-3 px-md-0 pt-3 pt-md-0`}
              >
                {m_show && (
                  <div className="btn-back" onClick={this._backBtn}>
                    <Icon name="md-arrow-back" color={color.black} size={25} />
                  </div>
                )}
                {this._renderCloseIcon()}
              </div>
            </div>
            <Row noGutters={true}>
              <Col xs={12}>
                {selected_area === undefined && (
                  <p className="pl-3">Please select a location</p>
                )}
                {!m_show ? this._renderLocation() : this._renderAreaDistrict()}
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    );
  }
}

Location.propTypes = {
  isFirstLoad: PropTypes.bool.isRequired,
  storeLocation: PropTypes.object.isRequired,
  locationModalVisible: PropTypes.bool.isRequired,
  showModalLocation: PropTypes.func,
  hideModalLocation: PropTypes.func,
  onGetListLocation: PropTypes.func.isRequired,
  locationList: PropTypes.array.isRequired,
  onSubmitLocation: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isFirstLoad: state.IsFirstLoad.isFirstLoad,
    locationModalVisible: state.Location.locationModalVisible,
    storeLocation: state.Location.storeLocation,
    locationList: state.Location.locationList,
    isLoading: state.Location.isLoading,
    device_token: state.Auth.device_token,
    isLoggedIn: state.Auth.isLoggedIn,
    auth: state.Auth,
    isDeviceRegistered: state.Auth.isDeviceRegistered,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showModalLocation: () => dispatch(actions.showModalLocation()),
    hideModalLocation: () => dispatch(actions.hideModalLocation()),
    onGetListLocation: () => dispatch(actions.getLocationList()),
    onSubmitLocation: (params) => dispatch(actions.submitLocation(params)),
    showModalAlertWalletPin: () =>
      dispatch(actions.showModalAlertSetWalletPin()),
    // updateIsFirstLoad: () => dispatch(actions.updateIsFirstLoad())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Location);
